import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppComponent } from './app.component';

import * as $ from 'jquery';

import { RestService } from './service/rest.service';
import { PageService } from './service/page.service';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from './material.module';

import { MainHtmlLayoutComponent } from './layouts/site/main-page/main-html-layout.component';
import { InnerHtmlLayoutComponent } from './layouts/site/inner-page/inner-html-layout.component';
import { LightboxModule } from 'ngx-lightbox';
import { SharedLocalModule } from './components/admin/shared/shared-local.module';
import { StoreModule } from '@ngrx/store';
import { reducer as reducerMessages } from './store/reducers/messages';
import { reducer as reducerVpo } from './store/reducers/vpo';
import { reducer as reducerUser } from './store/reducers/user';
import { reducer as reducerStructure } from './store/reducers/structure';
import { reducer as reducerComplaint } from './store/reducers/complaint';
import { reducer as reducerSystem } from './store/reducers/system';
import { metaReducers } from './store/reducers';
import { EffectsModule } from '@ngrx/effects';
import { VpoEffects } from './store/effects/VpoEffects';
import { AdminHtmlLayoutComponent } from './layouts/admin/admin-html/admin-html-layout.component';
import { ContentLayoutComponent } from './layouts/content/content-layout.component';
import { LoginPageComponent } from './pages/login/login-page.component';
import { UserEffects } from './store/effects/UserEffects';
import { TokenInterceptor } from './shared/auth/interceptor/token.interceptor';
import { AuthService } from './shared/auth/auth.service';
import { AuthGuard } from './shared/auth/auth-guard.service';
import { ToastrModule } from 'ngx-toastr';
import { ExtraDataInterceptor } from './shared/auth/interceptor/extra-data.interceptor';
import { StructureEffects } from './store/effects/StructureEffects';
import { SlickCarouselModule } from 'ngx-slick-carousel';

// locale
import { registerLocaleData } from '@angular/common';
import localeRu from '@angular/common/locales/ru';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentUtcDateAdapter } from './shared/adapters/moment-utc-date.adapter';
import { MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { ComplaintEffects } from './store/effects/ComplaintEffects';
// import { SocketIoConfig, SocketIoModule } from 'ngx-socket-io';
import { MaintenancePageComponent } from './pages/maintenance/maintenance-page.component';
// import { environment } from '../environments/environment';
import { NoCacheHeadersInterceptor } from './shared/interceptors/no-cache-headers.interceptor';

registerLocaleData(localeRu, 'ru');

// const config: SocketIoConfig = { url: environment.socketUrl, options: {
//     path: '/socket2',
//   } };


export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  // entryComponents: [], // dynamic load
  declarations: [
    AppComponent,
    MainHtmlLayoutComponent,
    InnerHtmlLayoutComponent,
    AdminHtmlLayoutComponent,
    ContentLayoutComponent,
    LoginPageComponent,
    MaintenancePageComponent
  ],
  imports: [
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    SharedLocalModule,
    HttpClientModule,
    LightboxModule,
    ToastrModule.forRoot(),
    StoreModule.forRoot({
      messages: reducerMessages,
      user: reducerUser,
      vpo: reducerVpo,
      structure: reducerStructure,
      complaints: reducerComplaint,
      system: reducerSystem,
    }, { metaReducers }),
    EffectsModule.forRoot([
      VpoEffects,
      UserEffects,
      StructureEffects,
      ComplaintEffects
    ]),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    FormsModule,
    MaterialModule,
    SlickCarouselModule,
    // SocketIoModule.forRoot(config)
  ],
  providers: [
    PageService,
    RestService,
    AuthService,
    AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ExtraDataInterceptor,
      multi: true
    },
    {
      provide: LOCALE_ID,
      useValue: 'ru-Ru'
    },
    { provide: MAT_DATE_LOCALE, useValue: 'ru-RU' },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    { provide: DateAdapter, useClass: MomentUtcDateAdapter },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: NoCacheHeadersInterceptor,
    //   multi: true
    // },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
